import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'billing-tiers' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
